module.exports = __webpack_public_path__ + "static/sheep3-0bcfcaa58cac0c30c86442a97ef0194a.jpeg";